import * as z from 'zod';

import { addressSchema } from './address';

import { dateTimeSchema } from '#packages/data-collection/value-objects/date-time';

export const auditTypeSchema = z.enum(['ea', 'bca']);
export type AuditType = z.infer<typeof auditTypeSchema>;

export const auditSchema = z.object({
  /**
   * Local identifier for the audit
   */
  localId: z.string().nonempty(),

  /**
   * Unique identifier for the audit (GUID format)
   * This field is used by the API to uniquely identify an audit.
   */
  serverId: z.guid().optional(),

  /**
   * Title of the audit
   */
  title: z.string().nonempty(),

  /**
   * Audit types associated with the audit
   */
  types: z.array(auditTypeSchema).min(1),

  /**
   * The project ID associated with the audit
   */
  projectId: z.string().optional(),

  /**
   * The address associated with the audit
   */
  address: z.object(addressSchema).optional(),

  /**
   * Timestamp when the audit was created
   */
  createdAt: dateTimeSchema,

  /**
   * Timestamp when the audit was last updated
   */
  updatedAt: dateTimeSchema,

  /**
   * The last time the audit was synced with the server
   */
  lastSync: dateTimeSchema.optional(),
});

export type Audit = z.infer<typeof auditSchema>;
